import { UI, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

export interface HeaderProps {
  handleCloseDetails: () => void;
  isMobile: boolean;
}

export const Header: React.FC<HeaderProps> = ({ handleCloseDetails, isMobile }) => {
  return (
    <HStack justifyContent="space-between" alignItems="center">
      <HStack alignItems="center" space={Spacing['stack.nano']}>
        <UI.IconButton
          icon="ArrowLeft"
          testId="return-button"
          shadow={isMobile ? undefined : 3}
          variant={isMobile ? 'unstyled' : 'link'}
          iconColor={isMobile ? Color['neutral.dark'] : Color['brand.tertiary.principal']}
          iconSize="xs"
          padding={{ base: 0, sm: Spacing['inset.nano'] }}
          onPress={handleCloseDetails}
        />
        {isMobile ? (
          <UI.Text fontSize={Typography['fontsize.lg']} variant="bold">
            Posição detalhada
          </UI.Text>
        ) : (
          <UI.Heading testId="customer-details-heading">Posição detalhada</UI.Heading>
        )}
      </HStack>
    </HStack>
  );
};
